<template>
    <div class="guid-tour" v-if="status !== 6">
        <div class="guild-1280">
            <img v-show="status === 1" class="step step-1" src="@/assets/img/component/guildTour/step1_1280.svg" alt="" srcset="">
            <img v-show="status === 2" class="step step-2" src="@/assets/img/component/guildTour/step2_1280.svg" alt="" srcset="">
            <img v-show="status === 3" class="step step-3" src="@/assets/img/component/guildTour/step3_1280.svg" alt="" srcset="">
            <img v-show="status === 4" class="step step-4" src="@/assets/img/component/guildTour/step4_1280.svg" alt="" srcset="">
            <img v-show="status === 5" class="step step-5" src="@/assets/img/component/guildTour/step5.svg" alt="" srcset="">
            <div class="explan explan1" v-show="status === 1">
                <img  class="explan" src="@/assets/img/component/guildTour/explan1.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
            <div class="explan explan2" v-show="status === 2">
                <img  class="explan" src="@/assets/img/component/guildTour/explan2.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
            <div class="explan explan3" v-show="status === 3">
                <img  class="explan" src="@/assets/img/component/guildTour/explan3.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
            <div class="explan explan4" v-show="status === 4">
                <img  class="explan" src="@/assets/img/component/guildTour/explan4.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
            <div class="explan explan5" v-show="status === 5">
                <img  class="explan" src="@/assets/img/component/guildTour/explan5.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
        </div>
        <div class="guild-large">
            <img id="step-first" v-show="status === 1" class="step step-1" src="@/assets/img/component/guildTour/step1.svg" alt="" srcset="">
            <img id="step-two" v-show="status === 2" class="step step-2" src="@/assets/img/component/guildTour/step2.svg" alt="" srcset="">
            <img id="step-three" v-show="status === 3" class="step step-3" src="@/assets/img/component/guildTour/step3.svg" alt="" srcset="">
            <img id="step-four" v-show="status === 4" class="step step-4" src="@/assets/img/component/guildTour/step4.svg" alt="" srcset="">
            <img id="step-five" v-show="status === 5" class="step step-5" src="@/assets/img/component/guildTour/step5.svg" alt="" srcset="">
            <div class="explan explan1" v-show="status === 1">
                <img  class="explan" src="@/assets/img/component/guildTour/explan1.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
            <div class="explan explan2" v-show="status === 2">
                <img  class="explan" src="@/assets/img/component/guildTour/explan2.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
            <div class="explan explan3" v-show="status === 3">
                <img  class="explan" src="@/assets/img/component/guildTour/explan3.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
            <div class="explan explan4" v-show="status === 4">
                <img  class="explan" src="@/assets/img/component/guildTour/explan4.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
            <div class="explan explan5" v-show="status === 5">
                <img  class="explan" src="@/assets/img/component/guildTour/explan5.svg" alt="" srcset="">
                <span class="next" @click="status += 1">我知道了</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            status: 1,
        }
    },
    mounted() {
        let menu = document.getElementsByClassName('biz-menu')[0]
        let todo = document.getElementsByClassName('bussiness-wrap')[0]
        reportWindowSize()
        function reportWindowSize() {
            document.getElementById('step-first').style.left = menu.offsetLeft+'px'
            document.getElementById('step-two').style.left = menu.offsetLeft+'px'
            document.getElementById('step-three').style.left = menu.offsetLeft+'px'
            document.getElementById('step-four').style.left = menu.offsetLeft+'px'
            document.getElementById('step-five').style.left = (todo.offsetLeft+21)+'px'
        }

        window.onresize = reportWindowSize;
    },
    watch: {
        status: function (val){
            if(val === 5){
                localStorage.removeItem('isGuided', false)
            }
        }
    },
    components: {
  
    }
}
</script>
<style lang="scss" scoped>
    .guid-tour{
        position: fixed; /* Stay in place */
        z-index: 999; /* Sit on top */
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgba(0,0,0,0.7); /* Black w/ opacity */
        overflow: hidden;
        .step{
            position: absolute;
        }
        .explan{
            position: absolute;
        }
        .next{
            position: absolute;
            color: #fcb773;
            font-size: 16px;
            font-weight: 500;
            width: 100px;
            bottom: 0;
            cursor: pointer;
        }
        .guild-1280{
            display: none;
        }
        .guild-large{
            .step{
                &.step-1{
                    top: 288px;
                }
                &.step-2{
                    top: 288px;
                }
                &.step-3{
                    top: 288px;
                }
                &.step-4{
                    top: 216px;
                }
                &.step-5{
                    top: 380px;
                }
            }
            .explan{
                &.explan1{
                    left: 23%;
                    top: 146px;
                    .next{
                        top: 173px;
                        margin-left: 106px;
                    }
                }
                &.explan2{
                    left: 23%;
                    top: 176px;
                    .next{
                        top: 170px;
                        margin-left: 106px;
                    }
                }
                &.explan3{
                    left: 23%;
                    top: 216px;
                    .next{
                        top: 170px;
                        margin-left: 106px;
                    }
                }
                &.explan4{
                    left: 23%;
                    top: 186px;
                    .next{
                        top: 170px;
                        margin-left: 106px;
                    }
                }
                &.explan5{
                    left: 40%;
                    top: 155px;
                    .next{
                        top: 170px;
                        margin-left: 106px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1440px) {
        .guid-tour{
            .guild-large{
                .explan{
                    &.explan1{
                        left: 16%;
                    }
                    &.explan2{
                        left: 16%;
                    }
                    &.explan3{
                        left: 16%;
                    }
                    &.explan4{
                        left: 16%;
                    }
                    &.explan5{
                        left: 40%;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .guid-tour{
            .guild-1280{
                display: block;
                .step{
                    &.step-1{
                        left: 20px;
                        top: 266px;
                    }
                    &.step-2{
                        left: 20px;
                        top: 266px;
                    }
                    &.step-3{
                        left: 20px;
                        top: 266px;
                    }
                    &.step-4{
                        left: 20px;
                        top: 206px;
                    }
                    &.step-5{
                        left: 100px;
                        top: 380px;
                    }
                }
                .explan{
                    &.explan1{
                        left: 218px;
                        top: 146px;
                        .next{
                            top: 173px;
                            margin-left: 106px;
                        }
                    }
                    &.explan2{
                        left: 218px;
                        top: 176px;
                        .next{
                            top: 170px;
                            margin-left: 106px;
                        }
                    }
                    &.explan3{
                        left: 218px;
                        top: 216px;
                        .next{
                            top: 170px;
                            margin-left: 106px;
                        }
                    }
                    &.explan4{
                        left: 218px;
                        top: 156px;
                        .next{
                            top: 170px;
                            margin-left: 106px;
                        }
                    }
                    &.explan5{
                        left: 422px;
                        top: 155px;
                        .next{
                            top: 170px;
                            margin-left: 106px;
                        }
                    }
                }
            }
           .guild-large{
               display: none;
            }
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tips/guidTour.vue